import StorageHelper from "../helpers/StorageHelper";
const storageHelper = new StorageHelper();

export class SiafLiteApiStream {
  constructor(url) {
    this.url = url;
    const localStorageToken = storageHelper.getLocal("token");
    this.authorization = `Bearer ${localStorageToken}`;
  }

  async path(body) {
    return fetch(this.url, {
      method: "PATCH",
      headers: {
        "Content-Type": "application/json",
        Authorization: this.authorization,
      },
      body: JSON.stringify(body),
    });
  }
}
